import {createApi} from "@reduxjs/toolkit/query/react";
import api from "@/store/api/api";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        login: build.mutation({
            query: (data) => ({
                url: api.user.login(),
                method: 'POST',
                body: data
            })
        }),
        register: build.mutation({
            query: (data) => ({
                url: api.user.register(),
                method: 'POST',
                body: data
            })
        }),
        verify: build.mutation({
            query: (data) => ({
                url: api.user.verify(),
                method: 'POST',
                body: data
            })
        }),
        resendEmail: build.mutation({
            query: () => ({
                url: api.user.resendEmail(),
                method: 'POST'
            })
        }),
        forgotPassword: build.mutation({
            query: (data) => ({
                url: api.user.forgotPassword(),
                method: 'POST',
                body: data
            })
        }),
        resetPassword: build.mutation({
            query: (data) => ({
                url: api.user.resetPassword(),
                method: 'POST',
                body: data
            })
        })
    })
})


export const { useResendEmailMutation } = authApi